import type { FC } from "react";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { Dropdown } from "@similarweb/ui-components";

import { getFinalTransitionParamsToKeywordDetailPage } from "app/pages/website-analysis/folders/utils";
import { allTrackers } from "app/services/track/track";
import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import {
    CellSiteWrapper,
    DropdownActionItem,
    DropdownActionItemContent,
    EllipsisDropdownItemStyled,
} from "./styledComponents";
import { keywordResearchConfig } from "single-spa/react-app/config/solutions25/keywordResearchConfig";

interface IDropDownItem {
    text: string;
    icon?: IconName;
    onClick: (value: string) => void;
}

const DROPDOWN_ITEMS: IDropDownItem[] = [
    {
        get text() {
            return translate("search.pages.table.columns.explore");
        },
        icon: "keywords",
        onClick: (value: string) => {
            proNavigator.go(
                keywordResearchConfig.organicsearch_websites_v2_traffic_keywords,
                getFinalTransitionParamsToKeywordDetailPage({ keyValue: value, searchType: "folder" }),
            );
        },
    },
    {
        get text() {
            return translate("search.pages.table.columns.copy");
        },
        icon: "organic-link",
        onClick: (value: string) => {
            navigator.clipboard.writeText(value);
        },
    },
    {
        get text() {
            return translate("search.pages.table.columns.open");
        },
        icon: "open-new-window",
        onClick: (value: string) => {
            window.open(`http://${value}`, "_blank", "noopener,noreferrer");
        },
    },
];

interface CellSiteWithDropdownProps {
    folderText: string;
    fullPathFolder: string;
}

export const CellSiteWithDropdown: FC<CellSiteWithDropdownProps> = ({ folderText, fullPathFolder }) => {
    const handleDropdownOnClick = (data: { children: string }) => {
        const item = DROPDOWN_ITEMS.find((item) => item.text === data.children);
        allTrackers.dispatchTrackEvent("Internal Link", "click", `Table/Folders/${fullPathFolder}`);
        item?.onClick(fullPathFolder);
    };

    const dropdownActionItem = (
        <DropdownActionItem>
            <DropdownActionItemContent>{folderText}</DropdownActionItemContent>
            <SWReactIcons iconName="arrow" />
        </DropdownActionItem>
    );

    const dropDownActions = DROPDOWN_ITEMS.map((option) => (
        <EllipsisDropdownItemStyled
            key={option.text}
            iconName={option.icon}
        >
            {option.text}
        </EllipsisDropdownItemStyled>
    ));

    return (
        <CellSiteWrapper>
            <Dropdown
                key={fullPathFolder}
                width={220}
                appendTo="body"
                dropdownPopupPlacement="bottom-left"
                onClick={handleDropdownOnClick}
            >
                {[dropdownActionItem, ...dropDownActions]}
            </Dropdown>
        </CellSiteWrapper>
    );
};
